import { InventoryAdjustmentDetailPage } from '@/features/inventory-adjustment/pages/InventoryAdjustmentDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentDetailPage,
})
